import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FileText, Briefcase, MessageSquare, Mail, ArrowRight } from 'lucide-react';
import { API_BASE } from '../../lib/api';

const API = API_BASE;
const getAuth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` } });

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/admin/stats`, getAuth())
      .then(res => setStats(res.data))
      .catch(e => { if (e.response?.status === 401) navigate('/admin'); });
  }, [navigate]);

  const cards = [
    { label: 'Posts de Blog', value: stats?.blog ?? '-', icon: FileText, color: '#7D468C', to: '/admin/blog' },
    { label: 'Casos de Estudio', value: stats?.cases ?? '-', icon: Briefcase, color: '#4EBFBF', to: '/admin/cases' },
    { label: 'Testimonios', value: stats?.testimonials ?? '-', icon: MessageSquare, color: '#F2785C', to: '/admin/testimonials' },
    { label: 'Contactos', value: stats?.contacts ?? '-', icon: Mail, color: '#233559', badge: stats?.unread_contacts, to: '/admin/contacts' },
  ];

  return (
    <div className="p-8" data-testid="admin-dashboard">
      <div className="mb-8">
        <h1 className="font-poppins font-bold text-2xl text-white">Dashboard</h1>
        <p className="text-white/40 font-source-sans text-sm mt-1">Bienvenido al panel de Mikel Media</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5 mb-10">
        {cards.map(card => {
          const Icon = card.icon;
          return (
            <button
              key={card.label}
              onClick={() => navigate(card.to)}
              data-testid={`stat-card-${card.to.split('/').pop()}`}
              className="group bg-[#1A2639] border border-white/8 p-6 text-left hover:border-[#7D468C]/40 transition-[transform,box-shadow,background-color,border-color,color,opacity,gap,backdrop-filter] duration-200 relative overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-20 h-20 opacity-5" style={{ backgroundColor: card.color, transform: 'rotate(45deg)', transformOrigin: 'top right' }} />
              <div className="flex items-start justify-between mb-4">
                <div className="w-10 h-10 flex items-center justify-center" style={{ backgroundColor: card.color + '20' }}>
                  <Icon size={18} style={{ color: card.color }} />
                </div>
                {card.badge > 0 && (
                  <span className="bg-[#F2785C] text-white text-xs px-2 py-0.5 font-poppins font-bold">{card.badge} new</span>
                )}
              </div>
              <div className="font-poppins font-black text-3xl text-white">{card.value}</div>
              <div className="text-white/40 text-sm font-source-sans mt-1 flex items-center justify-between">
                {card.label}
                <ArrowRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            </button>
          );
        })}
      </div>

      {/* Quick actions */}
      <div className="bg-[#1A2639] border border-white/8 p-6">
        <h2 className="font-poppins font-bold text-white mb-4">Acciones Rápidas</h2>
        <div className="flex flex-wrap gap-3">
          {[
            { label: 'Nuevo Post', to: '/admin/blog' },
            { label: 'Nuevo Caso', to: '/admin/cases' },
            { label: 'Nuevo Testimonio', to: '/admin/testimonials' },
          ].map(a => (
            <button
              key={a.to}
              onClick={() => navigate(a.to)}
              className="border border-[#7D468C]/40 text-[#7D468C] text-sm font-poppins font-semibold px-4 py-2 hover:bg-[#7D468C] hover:text-white transition-colors"
            >
              + {a.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
